import { useEffect, useState } from "react";
import axios from "axios";

function DownloadApp() {
  const [androidLink, setAndroidLink] = useState("");
  const [iosLink, setIosLink] = useState("");
  const [showUpdateScreen, setShowUpdateScreen] = useState(false);
  const server_url = localStorage.getItem("server_url");
  let version_code = localStorage.getItem("version_code");
  useEffect(() => {
    const timer = setTimeout(() => {
      check_version();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  function check_version() {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("version_code", version_code);

    axios
      .post(`${server_url}check_version.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        const data = res.data;
        setAndroidLink(data.android_store_link);
        setIosLink(data.ios_store_link);
        setShowUpdateScreen(true);
      })
      .catch((err) => {
        console.error("Version check failed", err);
      });
  }

  if (!showUpdateScreen) return null;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>🚨 App Update Required</h2>
        <p style={styles.text}>
          You're using an outdated version of the app. Please update to the
          latest version to continue using all features.
        </p>

        <div style={styles.buttons}>
          {androidLink && (
            <a
              href={androidLink}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Download on Android"
                style={styles.badge}
              />
            </a>
          )}
          {iosLink && (
            <a
              href={iosLink}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on iOS"
                style={styles.badge}
              />
            </a>
          )}
        </div>
       
      </div>
    </div>
  );
}

const styles = {
  page: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#eef2f5",
    minHeight: "100vh",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "40px 30px",
    maxWidth: "500px",
    textAlign: "center",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    color: "#333",
  },
  text: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "30px",
    lineHeight: "1.5",
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    flexWrap: "wrap",
  },
  link: {
    textDecoration: "none",
  },
  badge: {
    height: "55px",
  },
};

export default DownloadApp;
